import { Component, AfterViewInit, ElementRef, Renderer2, ViewEncapsulation } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { SharedService } from './../../services';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements AfterViewInit {

  constructor(
    private breakpointObserver: BreakpointObserver,
    private el: ElementRef,
    private _shared: SharedService,
    private readonly elementRef: ElementRef,
    private renderer: Renderer2,
  ) { }

  currentYear = (new Date()).getFullYear();

  layoutChanges = this.breakpointObserver.observe([
    'screen and (min-width: calc(1440px + 20px))',
    'screen and (min-width: calc(1280px + 20px)) and (max-width: calc(1440px + 20px))',
    'screen and (min-width: calc(1024px + 20px)) and (max-width: calc(1280px + 20px))',

    'screen and (min-width: calc(1000px)) and (max-width: calc(1024px + 20px))',

    'screen and (min-width: calc(768px + 20px)) and (max-width: calc(1000px))',
    'screen and (max-width: calc(768px + 20px))',
  ]);

  ngAfterViewInit() {
    this.layoutChanges.subscribe(result => {
      this._shared.changeFooterHeight(this.el.nativeElement.offsetHeight);
    });
  }

  ngOnInit() {
    let noindex = this.renderer.createElement('noindex');
    let imgSrc = `${"https://counter.yadro.ru/hit?t26.11;r"+escape(document.referrer)+
    ((typeof(screen)=="undefined")?"":";s"+screen.width+"*"+screen.height+"*"+
    (screen.colorDepth?screen.colorDepth:screen.pixelDepth))+";u"+escape(document.URL)+
    ";h"+escape(document.title.substring(0,150))+";"+Math.random()}`;
    this.renderer.setProperty(noindex,'innerHTML',`
    <a href="https://www.liveinternet.ru/click"
    target="_blank"><img id="licnt2654" width="88" height="15" style="border:0;"
    title="LiveInternet: показано число посетителей за сегодня"
    src="${imgSrc}"
    alt=""/></a>
    `);
    this.renderer.appendChild(
      this.elementRef.nativeElement.lastChild.lastChild,
      noindex
    );
  }

}
